import Vue from "vue";

Vue.filter("itemImagesUrlOverwrite", function(images, overwriteUrl = "", imageOptions = { size: 370 }) {
	if (!images) {
		return [];
	}

	const imageUrls = [];

	for (const image in images) {
		const currentImage = images[image];

		if (overwriteUrl.length) {
			currentImage.url = currentImage.url.replace(/https:\/\/(.*?)\/item\/images/, "https://" + overwriteUrl);
		}

		if (Object.keys(imageOptions).length > 1) {
			const assetParams =	"?scale.width=" + imageOptions.size +
							"&scale.height=" + imageOptions.size +
							(imageOptions.webp ? "" : "&format=original") +
							imageOptions.params;

			currentImage.url = currentImage.url + assetParams;
		}
        imageUrls.push(currentImage);
	}

	return imageUrls;
});
